import { useEffect, useState } from "react";
import { api } from "../../../../service/api";
import { StockAcquisitionDTO } from "../../../../dtos/StockAcquisitionDTO";

export function useListAcquisitionStock() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<boolean | null>(null);
  const [dataList, setDataList] = useState<StockAcquisitionDTO[]>([]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await api.get("company/stock/acquisition/list");
      setDataList(response.data);
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return {
    dataList,
    loading,
    error,
    refetch: fetchData,
  };
}
